import React from 'react';
import PropTypes from 'prop-types';

// Destaque: trecho entre **...** no título vira <strong> amarelo (padrão DS,
// onde parte do h1 aparece em --c-accent-yellow). Convenção leve pro editor.
const renderTitle = (title) => {
  if (!title) return null;
  return title.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    const m = part.match(/^\*\*([^*]+)\*\*$/);
    return m ? (
      <strong key={i} className="ag-page-banner__title-em">
        {m[1]}
      </strong>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    );
  });
};

const PageBannerView = ({ data }) => {
  const variant = data.variant || 'blue';
  const align = data.align || 'left';
  const titleUppercase = data.titleUppercase === true; // DS: caixa normal por padrão
  return (
    <header
      className={`ag-page-banner ag-page-banner--${variant} ag-page-banner--${align}`}
    >
      <span className="ag-page-banner__watermark" aria-hidden="true" />
      <div className="ag-page-banner__inner">
        {data.eyebrow && (
          <span className="ag-page-banner__eyebrow">{data.eyebrow}</span>
        )}
        {data.title && (
          <h1
            className={`ag-page-banner__title${titleUppercase ? ' ag-page-banner__title--uppercase' : ''}`}
          >
            {renderTitle(data.title)}
          </h1>
        )}
        {data.lede && <p className="ag-page-banner__lede">{data.lede}</p>}
      </div>
    </header>
  );
};

PageBannerView.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    lede: PropTypes.string,
    variant: PropTypes.string,
    align: PropTypes.string,
    titleUppercase: PropTypes.bool,
  }).isRequired,
};

export default PageBannerView;
